export default __webpack_public_path__ + "static/media/in-ka.1bf9436e.svg";